/* eslint-disable import/max-dependencies */
import { combineReducers, createStore, compose, applyMiddleware } from "redux";
import type { Store, AnyAction } from "redux";
import {
  formReducer,
  initFormState,
  type FormState,
  notificationsReducer,
  initNotificationsState,
  type NotificationsState,
  errorsReducer,
  initErrorsState,
  type ErrorsState,
  loadingReducer,
  initLoadingState,
  type LoadingState,
} from "@fas/ui-framework";
import {
  LOGIN_FORM,
  AUTOLOGIN_FORM,
  RESTORE_PASSWORD_FORM,
  CHANGE_PASSWORD_FORM,
} from "@fas/cpa-state-manager/redux/constants";
import Immutable from "immutable";
import createSagaMiddleware from "redux-saga";
import mainSaga from "./saga";

export type State = {
  form: FormState;
  loading: LoadingState;
  notifications: NotificationsState;
  errors: ErrorsState;
};
export type Actions = AnyAction;
export type AuthStore = Store<State, Actions>;

const mapAuthToState: () => State = () => ({
  form: initFormState({
    [LOGIN_FORM]: {
      login: "",
      password: "",
    },
    [AUTOLOGIN_FORM]: {
      email: "",
    },
    [RESTORE_PASSWORD_FORM]: {
      email: "",
    },
    [CHANGE_PASSWORD_FORM]: {
      password: "",
      confirmation: "",
    },
  }),
  loading: initLoadingState({
    [LOGIN_FORM]: false,
    [AUTOLOGIN_FORM]: false,
    [RESTORE_PASSWORD_FORM]: false,
    [CHANGE_PASSWORD_FORM]: false,
  }),
  notifications: initNotificationsState(),
  errors: initErrorsState(),
});

const reducers = combineReducers({
  form: formReducer,
  loading: loadingReducer,
  notifications: notificationsReducer,
  errors: errorsReducer,
});
const sagaMiddleware = createSagaMiddleware();

export default (): AuthStore => {
  const composeEnhancers =
    // eslint-disable-next-line no-underscore-dangle, flowtype/require-variable-type
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      serialize: {
        immutable: Immutable,
      },
    })
      : compose;
  const store = createStore(
    reducers,
    mapAuthToState(),
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );
  sagaMiddleware.run(mainSaga);
  return store;
};
